export const START_INTERVAL = "START_INTERVAL";
export const RUNNING_INTERVAL = "RUNNING_INTERVAL";
export const STOP_INTERVAL = "STOP_INTERVAL";
export const REFRESH_AUTH_TOKEN = "REFRESH_AUTH_TOKEN";